<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Datos de usuario</h3>
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleProfileUpdate">
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group text-center">
                    <div v-if="image" class="profile-image card-img pb-4">
                      <img
                        :src="`${image}`"
                        class="profile-image argon-image"
                      />
                    </div>
                    <div v-else class="profile-image text-center">
                      <img
                        src="/img/placeholder.png"
                        class="argon-image"
                        width="212"
                      />
                    </div>
                    <div class="image-upload text-center">
                      <base-button
                        v-if="image"
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="removeImage"
                      >
                        <span>
                          <i class="fa fa-times" />
                          Eliminar
                        </span>
                      </base-button>
                      <base-button type="button" class="btn btn-sm btn-primary">
                        <label v-if="!image" for="imageInput" class="mb-0"
                          >Seleccionar imagen</label
                        >
                        <label v-else for="imageInput" class="mb-0"
                          >Cambiar</label
                        >
                        <input
                          id="imageInput"
                          ref="imageInput"
                          accept="image/*"
                          type="file"
                          style="display: none"
                          @change="onSelectFile"
                        />
                      </base-button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Email"
                        placeholder="Email"
                        v-model="user.email"
                      />
                      <validation-error :errors="apiValidationErrors.email" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Nombre de usuario"
                        placeholder="Nombre"
                        v-model="user.username"
                      />
                      <validation-error
                        :errors="apiValidationErrors.username"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Nombre"
                        placeholder="Nombre"
                        v-model="user.nombre"
                      />
                      <validation-error :errors="apiValidationErrors.nombre" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Apellidos"
                        placeholder="Apellidos"
                        v-model="user.apellidos"
                      />
                      <validation-error
                        :errors="apiValidationErrors.apellidos"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input label="Rol">
                        <el-select
                          name="role"
                          v-model="user.role.id"
                          prepend-icon="fas fa-user"
                        >
                          <el-option
                            v-for="role in available_roles"
                            :key="role.id"
                            :value="role.id"
                            :label="role.name"
                          >
                          </el-option>
                        </el-select>
                      </base-input>
                      <validation-error :errors="apiValidationErrors.roles" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Teléfono"
                        placeholder="Teléfono"
                        v-model="user.telefono"
                      />
                      <validation-error
                        :errors="apiValidationErrors.telefono"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="my-2 text-right">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Actualizar usuario
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";

export default {
  name: "UserEditCard",

  components: {
    BaseInput,
    BaseButton,
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [formMixin],

  /*  props: {
    user: Object,
  }, */

  data() {
    return {
      image: null,
      file: null,
      available_roles: [],
      user: {
        type: "users",
        username: null,
        email: null,
        password: null,
        password_confirmation: null,
        profile_image: null,
        imagen_perfil: null,
        activo: null,
        blocked: null,
        confirmed: null,
        cif: null,
        estado_usuario: null,
        telefono: null,
        nombre: null,
        apellidos: null,
        /*  relationshipNames: ["roles"], */
        roles: [
          {
            type: "roles",
            id: null,
          },
        ],
      },
    };
  },

  created() {
    this.get();
    this.getRoles();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("profile/me");
        let profile = await this.$store.getters["profile/me"];

        console.log(profile);
        const id = profile.id;
        await this.$store.dispatch("users/get", id);

        this.user = await this.$store.getters["users/user"];

        console.log(this.user);
        if (this.user.imagen_perfil) {
          this.image = this.user.imagen_perfil.url;
        }

        console.log(this.user);
        console.log(this.image);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    async onSelectFile(e) {
      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    getRoles() {
      try {
        this.$store.dispatch("roles/list").then(() => {
          this.available_roles = cloneDeep(
            this.$store.getters["roles/dropdown"]
          );
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    removeImage() {
      this.image = null;
    },

    async handleProfileUpdate() {
      this.user.role = {
        disconnect: [],
        connect: [{ id: this.user.role.id, position: { end: true } }],
      };

      if (this.file) {
        console.log(this.file);
        await this.$store.dispatch("items/upload", {
          item: this.tipo,
          image: this.file,
        });

        this.user.imagen_perfil = await this.$store.getters["items/url"];
      }

      console.log(this.user);

      try {
        await this.$store.dispatch("users/update", this.user);
        this.$notify({
          type: "success",
          message: "Usuario actualizado correctamente.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        console.log(error);
        console.log(error.response.data.errors);
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
  },
};
</script>
